import Image from 'next/image';

import { Card } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypePressCardProps } from './types';

/**
 * PressCard
 */
export const PressCard: FunctionComponent<TypePressCardProps> = ({
  backgroundColor,
  className = '',
  company,
  desc,
  image,
}: TypePressCardProps) => (
  <Card
    className={`${className} flex flex-col !rounded-md`}
    backgroundColor={backgroundColor}
  >
    <div className="flex flex-col gap-6">
      <div className="flex flex-row justify-start gap-4">
        <div className="relative h-8 w-8 rounded-full">
          <Image
            src={image}
            layout="fill"
            objectFit="cover"
            className="rounded-full"
          />
        </div>
        <span className="text-subtitle text-subtitle--large">{company}</span>
      </div>
      <div>
        <p className="text-bold text-body text-body--primary">{desc}</p>
      </div>
    </div>
  </Card>
);

PressCard.displayName = 'PressCard';
